<template>
  <ion-page>
    <ion-content>
      <the-header :show-avatar="false" />
      <div class="preview-container">
        <ion-icon src="/assets/icon/auth-logo-icon.svg" />
      </div>
      <div class="auth-page">
        <div class="content-container">
          <auth-banner class="auth-page__bunner" />
          <div class="auth-page__buttons-container">
            <base-button
              class="auth-page__button auth-page__button--signup"
              secondary
              @click="handleSignupClick"
            >
              {{ t('signUp') }}
            </base-button>

            <div class="auth-page__buttons-text">
              {{ t('authButtonsText') }}
            </div>
            <div
              class="auth-page__button auth-page__button--signin"
              @click="handleSigninClick"
            >
              {{ t('signIn') }}
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonPage, IonIcon } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { logEvent } from '@/services/analytics';
import { useInternalization } from '@/composables/useInternalization';

import TheHeader from '@/components/TheHeader.vue';
import BaseButton from '@/components/BaseButton.vue';
import AuthBanner from '@/components/AuthBanner.vue';

const router = useRouter();
const { t } = useInternalization();

logEvent('view_auth-page');

function handleSigninClick() {
  router.push({ name: 'SignIn' });
}
function handleSignupClick() {
  router.push({ name: 'SignUp' });
}
</script>

<style lang="scss" scoped>
.auth-page {
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 6em;
  }

  &__bunner {
    width: 100%;
    position: relative;
    z-index: 3;
    max-width: 600px;
  }

  &__buttons-container {
    margin-top: 2em;
    width: 100%;
    max-width: 600px;
    text-align: center;

    & > *:last-child {
      margin-top: 1em;
    }
  }

  &__buttons-text {
    font-size: 16px;
    line-height: 20px;
    color: #172659;
    text-align: center;
    margin-top: 1em;
  }

  &__button {
    cursor: pointer;
    &--signup {
      --background: #6289ff !important;
      --color: #fff;
    }
    &--signin {
      text-decoration-line: underline;
    }
  }
}

.preview-container {
  margin-top: 4vh;
  height: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ion-icon {
    width: 100%;
    height: 100%;
    max-width: 160px;
    margin-bottom: 2em;
  }
}
</style>
